import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import OrderExchangeListWrap from '../../views/order/exchange/list/OrderExchangeListWrap';
import { orderActions } from '../../store/modules/order';
import {
  ORDER_EXCHANGE_LIST_FILTER_OPTION_MODEL,
  ORDER_EXCHANGE_LIST_SEARCH_DATA_MODEL,
  ORDER_EXCHANGE_LIST_SEARCH_OPTION_MODEL,
  ORDER_EXCHANGE_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/order/models';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';

class OrderExchangeListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { setData } = this.props;
    this.getList({
      searchOption: ORDER_EXCHANGE_LIST_SEARCH_OPTION_MODEL,
      filterOption: ORDER_EXCHANGE_LIST_FILTER_OPTION_MODEL,
      sortOption: ORDER_EXCHANGE_LIST_SORT_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });

    /**
     *  검색 박스 초기화
     */
    setData({
      path: ['orderExchangeList', 'searchData'],
      value: ORDER_EXCHANGE_LIST_SEARCH_DATA_MODEL,
    });
  };

  getList = (data) => {
    const { getOrderExchangeList, orderExchangeList } = this.props;
    const { searchOption, filterOption, sortOption, pagination } = orderExchangeList;

    getOrderExchangeList({
      searchOption,
      filterOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getOrderExchangeListExcelDownload, pageName, orderExchangeList, adminInfo } = this.props;

    if (!orderExchangeList || !orderExchangeList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getOrderExchangeListExcelDownload({
      email: adminInfo.email,
      searchOption: orderExchangeList.searchOption,
      filterOption: orderExchangeList.filterOption,
      sortOption: orderExchangeList.sortOption,
      orderPageName: pageName,
    });
  };

  render() {
    const { setData, orderExchangeList, mainProductCategorySelectList } = this.props;

    return (
      <OrderExchangeListWrap
        setData={setData}
        orderExchangeList={orderExchangeList}
        mainProductCategorySelectList={mainProductCategorySelectList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    orderExchangeList: state.order.orderExchangeList,
    mainProductCategorySelectList: state.order.mainProductCategorySelectList,
  };
};

const mapDispatchToProps = {
  setData: orderActions.setData,
  getOrderExchangeList: orderActions.getOrderExchangeList,
  getOrderExchangeListExcelDownload: orderActions.getOrderExchangeListExcelDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderExchangeListContainer);
